/**
 * @react-pdf utility hook to allow hyphenation after every char
 */
export function useBreakAll() {
	return {
		hyphenationCallback: (word: string) => word.split('')
	}
}